import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";

import shareIcon from "../../../assets/images/share.png";
import closeIcon from "../../../assets/images/close.png";
import arrowIcon from "../../../assets/images/Vector_btn.png";

export default function Documenti({ isOpen, onClose }) {
  const overlayRef = useRef(null);

  const onShare = (popupId) => {
    const url = new URL(window.location.href);
    url.searchParams.set("popup", popupId);

    if (navigator.share) {
      navigator
        .share({ title: "Documenti di sostenibilità", url: url.toString() })
        .catch(() => {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(url.toString()).catch(() => {});
    }
  };

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose?.();
    if (isOpen) {
      document.body.classList.add("overflow-hidden");
      window.addEventListener("keydown", onKey);
    }
    return () => {
      document.body.classList.remove("overflow-hidden");
      window.removeEventListener("keydown", onKey);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

 // 1) Sostituisci l'array docs con:
const docs = [
  {
    label: "Bilancio Consolidato Integrato",
    href: "https://www.realegroup.eu/groupshare/0/IT/ListaReportsAndAccounts/87/BILANCIO%20CONSOLIDATO%20RG%202025.pdf",
  },
  {
    label: "Sustainability Statement\nExecutive Summary",
    href: "https://www.realegroup.eu/groupshare/0/IT/Documents/Sostenibilit%C3%A0/2025/EXECUTIVE%20SUMMARY%202025%20(2).pdf",
  },
  {
    label: "Relazione PSI",
    href: "https://www.realegroup.eu/groupshare/0/IT/Documents/Sostenibilit%C3%A0/2026/RELAZIONE%20PSI%202025%20def.pdf",
  },
  {
    label: "Certificazione ISO 14001 di Reale Group",
    href: "https://www.realegroup.eu/groupshare/0/IT/Documents/Sostenibilit%C3%A0/CertificatoRINA2024-2027.pdf",
  },
  {
    label: "Linee guida di Gruppo in ambito ambientale",
    href: "https://www.realegroup.eu/groupshare/0/IT/Documents/Sostenibilit%C3%A0/LINEE%20GUIDA%20IN%20AMBITO%20AMBIENTALE%20DEF.pdf",
  },
  {
    label: "Politica per la parità di genere",
    href: "https://www.realegroup.eu/groupshare/0/IT/PublishingImages/RESPONSIVE/ChiSiamo/Paritadigenere/240710%20Politica%20Parit%C3%A0%20di%20Genere_v1%20(2).pdf",
  },
  {
    label: "Codice Etico",
    href: "https://www.realegroup.eu/groupshare/0/IT/Documents/Istituzionale/Sostenibilita/Codice%20Etico%202024.pdf",
  },
  {
    label: "Relazione di Impatto",
    href: "https://www.realegroup.eu/groupshare/0/IT/Documents/Sostenibilit%C3%A0/Relazione%20di%20Impatto%202025.pdf",
  },
];


  return createPortal(
    <div
      ref={overlayRef}
      className="fixed inset-0 z-[1400] bg-black/50 backdrop-blur-[2px] flex items-center justify-center p-3 md:p-6"
      onMouseDown={(e) => {
        if (e.target === overlayRef.current) onClose?.();
      }}
      role="dialog"
      aria-modal="true"
      aria-label="Documenti di Sostenibilità"
    >
      <div
        className="relative w-full md:w-[1280px] bg-white max-h-[90vh] overflow-y-auto overscroll-contain"
        style={{ background: "#E7E3DF", WebkitOverflowScrolling: "touch" }}
        onMouseDown={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="sticky top-3 z-10 flex items-center gap-2 justify-end pr-3">
          <button
            onClick={() => onShare("Documenti")}
            className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-white/90 border border-[#0E3761]/30 hover:bg-white transition"
            title="Condividi"
            aria-label="Condividi"
          >
            <img src={shareIcon} alt="" className="h-4 w-4" />
          </button>
          <button
            onClick={onClose}
            className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-white/90 border border-[#0E3761]/30 hover:bg-white transition"
            title="Chiudi"
            aria-label="Chiudi"
          >
            <img src={closeIcon} alt="Chiudi" className="h-4 w-4" />
          </button>
        </div>

        {/* Content */}
        <div className="p-8">
          <h2 className="text-[#004996] text-[30px] md:text-[40px] font-bold">
            Documenti di sostenibilità
          </h2>

          {/* Grid: 1 col mobile, 3 col desktop */}
          <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-8 justify-items-center">
            {docs.map(({ label, href }, i) => (
              <a
                key={i}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                className="
                  group
                  inline-flex items-center gap-3 w-[350px] max-w-full
                  min-h-[60px] px-6
                  rounded-full border-2
                  border-[#0E3761] text-[#0E3761]
                  hover:bg-[#0E3761] hover:text-white
                  transition-colors
                "
                title={label.replace(/\n/g, " ")}
              >
                <img
                  src={arrowIcon}
                  alt=""
                  className="w-[25px] h-[25px] transition"
                />
                <span className="whitespace-pre-line text-left font-bold">
                  {label}
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
}
